import React from "react";
import { Stack } from "@mui/system";
import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";
import { Link } from "../buttons";

const useStyles = makeStyles(() => ({
  styledTextfield: {
    "& .MuiInputBase-root": {
      borderRadius: "12px",
    },
  },
}));
export interface SignupFormInterface {
  initialData: {
    name: string;
    email: string;
    password: string;
    c_password: string;
  };
  schema: any;
  handleAction: (type: string, data?: any) => void;
}
const SignupForm = ({
  initialData,
  schema,
  handleAction,
}: SignupFormInterface) => {
  const classes = useStyles();

  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700}>
          Welcome to EventView360!
        </Typography>
        <Typography variant="h4" fontWeight={500}>
          Getting started is easy
        </Typography>
      </Stack>
      <Formik
        initialValues={initialData}
        validationSchema={Yup.object().shape(schema)}
        onSubmit={(values) => handleAction("submit", values)}
        render={({
          handleChange,
          values,
          touched,
          errors,
          handleSubmit,
        }: any) => (
          <Stack width="50%">
            <form onSubmit={handleSubmit}>
              <Stack spacing={0.5}>
                <Typography>Full Name</Typography>
                <TextField
                  className={classes.styledTextfield}
                  placeholder="John Doe"
                  fullWidth
                  style={{ border: 0, padding: 0 }}
                  id="name"
                  helperText={
                    touched.name && errors !== null ? errors.name : ""
                  }
                  error={touched.name && errors !== null && errors.name}
                  onChange={handleChange}
                  value={values.name}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} mt={1.5}>
                <Typography>Email</Typography>
                <TextField
                  className={classes.styledTextfield}
                  placeholder="johndoe@gmail.com"
                  fullWidth
                  id="email"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.email && errors !== null ? errors.email : ""
                  }
                  error={touched.email && errors !== null && errors.email}
                  onChange={handleChange}
                  value={values.email}
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type="password"
                  placeholder="*********"
                  fullWidth
                  id="password"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.password && errors !== null ? errors.password : ""
                  }
                  error={touched.password && errors !== null && errors.password}
                  onChange={handleChange}
                  value={values.password}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography> Confirm Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type="password"
                  placeholder="*********"
                  fullWidth
                  id="c_password"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.c_password && errors !== null
                      ? errors.c_password
                      : ""
                  }
                  error={
                    touched.c_password && errors !== null && errors.c_password
                  }
                  onChange={handleChange}
                  value={values.c_password}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "primary",
                        border: "1px solid primary",
                        "&.Mui-checked": {
                          color: "primary",
                        },
                      }}
                    />
                  }
                  label=" I agree to Privacy Policy"
                />
              </Stack>
              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                  onClick={() => handleSubmit()}
                >
                  Create Account
                </Button>
              </Box>
              <Box mt={2} textAlign="center">
                Already have an account?{" "}
                <Link label="login" onClick={() => handleAction("login")} />
              </Box>
            </form>
          </Stack>
        )}
      />
    </Stack>
  );
};
export default SignupForm;
